const localizers = {
  'loading.msg': () => `Učitavanje...`,
  'SASServer.genericError.msg': () => `Nije moguće uspostaviti vezu sa serverom.`,
  'SASReport.genericError.msg': () => `Nije moguće učitati izabrani izveštaj.`,
  'SASReportImage.genericError.msg': () => `Učitavanje slike izveštaja nije uspelo.`,
  'SASReportImage.imageNotSupported.msg': () => `Slike nisu podržane za ovaj tip sadržaja izveštaja.`,
}
export default localizers;
